import { render } from "./AudioChoice.vue?vue&type=template&id=846d6992&scoped=true"
import script from "./AudioChoice.vue?vue&type=script&lang=js"
export * from "./AudioChoice.vue?vue&type=script&lang=js"

import "./AudioChoice.vue?vue&type=style&index=0&id=846d6992&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-846d6992"

export default script